/**
 * Module Administration (bible §18) — fondation V1 : comprendre et contrôler
 * le CRM sans toucher au code. Réservé au rôle admin.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "admin",
  label: "Administration",
  icon: "i-settings",
  navGroup: "administration",
  navOrder: 10,
  // super_admin est additif (Dove porte les deux) — sans lui ici, le rôle
  // n'aurait AUCUNE route montée (registry.invariants « route d'accueil »).
  rolesRequis: ["admin", "super_admin"],
  routes: [{ path: "/admin", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
